import { render, staticRenderFns } from "./TransitFilter.vue?vue&type=template&id=5b52242c&scoped=true&"
import script from "./TransitFilter.vue?vue&type=script&lang=js&"
export * from "./TransitFilter.vue?vue&type=script&lang=js&"
import style0 from "./TransitFilter.vue?vue&type=style&index=0&id=5b52242c&scoped=true&lang=css&"
import style1 from "./TransitFilter.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52242c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/joeldev/Developer/clientes/aduanas-pty/front-transit/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VDatePicker,VFlex,VIcon,VLayout,VMenu,VSelect,VTextField})
